import { observable } from 'mobx';

export let didClick = observable.box(false);
export const click = () => didClick.set(true);



// WEBPACK FOOTER //
// ./src/models/didClick.ts